<!--
  O chat (e o CopilotKit inteiro) fica num chunk separado via @defer, para que
  a página e o layout com a sidebar renderizem sem esperar esse download.
-->
@defer (on immediate) {
<datasafra-agent-chat></datasafra-agent-chat>
} @placeholder {
<div class="agent-loading">
  <mat-spinner diameter="48"></mat-spinner>
</div>
}
